exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-bg[data-v-3a76f1d1]{background-color:var(--cockpitTabsActiveColor)!important;line-height:28px!important}", ""]);

// exports
